import React, { Component } from 'react';
import { Modal, Button, Input, Radio, Spin, Popover, message } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import UploadFile from '../../../common/UploadFile';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

const RadioGroup = Radio.Group;

class ProjectRequestFinish extends Component {
    state = {
        loading: false,
        visible: false,
        contractList: [],
        fileList: [],
        record: {},
        data: {},
        role: '',
    }

    show = (record, role) => {
        this.setState({
            role,
            record,
            visible: true,
        }, () => {
            this.queryContractInfo();
        });
    }

    hide = () => {
        this.setState({
            data: {},
            fileList: [],
            contractList: [],
            visible: false,
        });
    }

    queryContractInfo = () => {
        const { invId } = sessionStorage;
        const { record: { investigationId, jdeMainId, investigationJdeContractId, remittanceCompletedInfoShow, invRemittanceCompletedInfoShow } } = this.state;
        let isConfirm, url, params = {};
        const remittanceCompletedInfo = invId > 0 ? invRemittanceCompletedInfoShow : remittanceCompletedInfoShow;
        if (remittanceCompletedInfo === '未确认' || remittanceCompletedInfo === 'PM拒绝确认' || remittanceCompletedInfo === 'FIN拒绝确认') {
            isConfirm = false;
            url = API_URL.contract.queryInvestigationCompleteApply;
            params.investigationId = investigationId;
        } else {
            isConfirm = true;
            url = API_URL.contract.queryInvestigationMainCompleteApply;
            params.investigationJdeContractId = invId > 0 ? jdeMainId : investigationJdeContractId;
        }
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url,
            data: {
                ...params,
                type:'invCloseOtherSupportFile',
            },
            dataType: 'json',
            doneResult: res => {
                const { applies, investigation = {}, apply = {} } = res;
                const { files } = apply;
                const { invFiles } = investigation;
                const fileList = (files || invFiles|| []).map((item, index) => ({
                    fileMateId: item.fileMateId,
                    name: item.name,
                    response: { fileMetaId: item.fileMateId },
                    uid: index,
                }));
                if (isConfirm) {
                    const { investigationJdeContractMainCode: mainCode, ...rest } = apply;
                    this.setState({
                        fileList,
                        data: {
                            ...rest,
                            mainCode,
                        },
                    });
                } else {
                    this.setState({ data: investigation, fileList });
                }
                this.setState({
                    contractList: applies,
                    loading: false,
                }, () => {
                    const { contractList } = this.state;
                    (contractList || []).forEach((item, index) => this.loadAttachList(item.investigationJdeContractId, index));
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadAttachList = (investigationJdeContractId, index) => {
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeCodeEnclosure,
            data: {
                investigationJdeContractId,
            },
            dataType: 'json',
            doneResult: res => {
                const { contractList } = this.state;
                contractList[index].attachList = res.data;
                this.setState({ contractList });
            },
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { role, data, fileList, record } = this.state;
        const { invId } = sessionStorage;
        const { investigationJdeContractId, jdeMainId, mainInvestigationJdeContractCode: investigationJdeContractMainCode } = record;
        const { comments, approvalStatus, reason, investigationMainCompletedApplyId: investigationJdeContractCompletedApplyId } = data;

        let url, params;
        if (role === 'BA') {
            params = {
                comments,
                investigationJdeContractId: invId > 0 ? jdeMainId : investigationJdeContractId,
                investigationJdeContractMainCode,
            };
            fileList.forEach((item, index) => {
                params[`ids[${index}]`] = item.response.fileMetaId;
            });
            url = API_URL.contract.addInvestigationCompleteApply;
        } else {
            if (!approvalStatus) {
                message.warning('请确认项目请款是否完成！');
                return;
            } else if (approvalStatus === 'REJECT' && !reason) {
                message.warning('请填写拒绝原因！');
                return;
            }

            params = { investigationJdeContractCompletedApplyId };
            params.type = 'INVESTIGATION';
            params.approvalStatus = approvalStatus;
            params.reason = reason;
            if (role === 'PM' || role === 'CRC' || role === 'CRCC' || role === 'CRCM') {
                url = API_URL.contract.pmExamineAndVerifyApply;
            } else {
                url = API_URL.contract.finExamineAndVerifyApply;
            }
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: params,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    handleInputChange = (e, key) => {
        const { data } = this.state;
        data[key] = e.target.value;
        if (key === 'approvalStatus') {
            data.reason = undefined;
        }
        this.setState({ data });
    }

    handleUploadChange = (file, fileList) => {
        this.setState({ fileList });
    }

    getTable = () => {
        const { contractList } = this.state;
        const columns = [{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
        }, {
            title: '合同附件',
            dataIndex: 'attachList',
            key: 'attachList',
            render: (text, record) => {
                return (text || []).map(item => <a key={item.id} onClick={e => this.downLoadFile(e, item.id)}>{item.name}<br/></a>);
            }
        }, {
            title: '合同性质',
            dataIndex: 'contractNature',
            key: 'contractNature',
            width: 80,
        }, {
            title: '币种',
            dataIndex: 'currency',
            key: 'currency',
            width: 100,
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 60,
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '合同额含税/人民币',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '已请款金额/人民币',
            dataIndex: 'cashReqAmount',
            key: 'cashReqAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '已回款金额/人民币',
            dataIndex: 'contractBackAmount',
            key: 'contractBackAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '合同请款完成情况',
            dataIndex: 'applyStatus',
            key: 'applyStatus',
            width: 100,
            render: (value, row) => {
                const { pmConfirmUserName, pmConfirmEmployeeCode, finConfirmUserName, finConfirmEmployeeCode } = row;
                const node = (
                    <div>
                        {`PM确认: ${pmConfirmUserName}[${pmConfirmEmployeeCode}]`}
                        <br />
                        {`FIN确认: ${finConfirmUserName}[${finConfirmEmployeeCode}]`}
                    </div>
                );
                return (
                    <Popover placement="right" overlayClassName="contract-pop" content={node}>
                        <div>
                            <i className='pop'></i>
                            FIN已确认
                        </div>
                    </Popover>
                );
            },
        }];
        return (
            <TableC
                data={contractList}
                columns={columns}
            />
        );
    }

    getContent = () => {
        const {
            role,
            data,
            fileList,
        } = this.state;
        const { investigationName, mainCode, comments, approvalStatus, reason } = data;

        const uploadParams = {
            uploadType: 'CONTRACT_COMPLETE_APPLY',
            path: Date.now(),
            relateId: '',
        };
        const asterisk = <span style={{color: 'red'}}>*</span>;
        return (
            <div>
                <div style={{ marginBottom: 16 }}>
                    项目简称：{investigationName}
                    <span className="ant-divider" />
                    JDE主项目号：{mainCode}
                </div>
                { this.getTable() }
                <ul className="modal-list">
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '20%' }}>备注:</div>
                        <div className="item-right" style={{ width: '80%' }}>
                            {
                                role === 'BA' ?
                                    <Input
                                        maxLength="255"
                                        value={comments}
                                        placeholder="请输入"
                                        style={{width: 300}}
                                        onChange={e => this.handleInputChange(e, 'comments')}
                                    />
                                :
                                    comments
                            }
                        </div>
                    </li>
                    <li className="modal-item">
                        <div className="item-left" style={{ width: '20%' }}>其他支持性文件:</div>
                        <div className="item-right" style={{ width: '80%' }}>
                            {
                                role === 'BA' ?
                                    <UploadFile
                                        data={uploadParams}
                                        fileList={fileList}
                                        uploadUrl={API_URL.proContract.uploadJdeCodeEnclosure}
                                        removeUrl={API_URL.proContract.deleteJdeCodeEnclosure}
                                        onChange={this.handleUploadChange}
                                    >
                                        <div>
                                            <Button style={{width: 80}}>选择文件</Button>
                                            <p style={{color: '#ffa500'}}>请上传和客户确认最终结算金额的邮件或其他支持性文件以备查看</p>
                                        </div>
                                    </UploadFile>
                                :
                                    fileList.map(i => <a key={i.fileMateId} onClick={e => this.downLoadFile(e, i.fileMateId)}>{i.name}<br/></a>)
                            }
                        </div>
                    </li>
                    {
                        role !== 'BA' &&
                        <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                            <div className="item-left" style={{ width: '20%' }}>{asterisk}{role=='FIN'?'FIN':'PM'}是否确认项目请款完成:</div>
                            <div className="item-right" style={{ width: '80%' }}>
                                <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                                    <Radio value='AGREE'>确认</Radio>
                                    <Radio value='REJECT'>拒绝</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    }
                    {
                        role !== 'BA' && approvalStatus === 'REJECT' &&
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '20%' }}>{asterisk}拒绝原因:</div>
                            <div className="item-right" style={{ width: '80%' }}>
                                <Input
                                    maxLength="255"
                                    value={reason}
                                    placeholder="请填写拒绝原因"
                                    style={{width: 300}}
                                    onChange={e => this.handleInputChange(e, 'reason')}
                                />
                            </div>
                        </li>
                    }
                </ul>
            </div>
        );
    }

    render() {
        const { visible, loading, role } = this.state;
        return (
            <Modal
                title={role === 'BA' ? '项目确认请款完成申请' : '确认项目请款完成'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="1100px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        { this.getContent() }
                    </Spin>
                </div>
            </Modal>
        ); 
    }
}

export default ProjectRequestFinish;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/ProjectRequestFinish.js